import React, { useContext, useEffect, useRef, useState } from "react";
import { Tag } from "../../../../../components/Tags/Tag";
import "./QuoteVendorPRNList.css";
import { Sorting } from "../../../../../components/Lists/Sorting";
import { Expandable } from "../../../../../components/Expandable/Expandable";
import { Tooltip } from "@mui/material";
import {
  DropdownsContext,
  DropdownsProvider,
} from "../../../../../contexts/DropdownsContext";
import Skeleton from "react-loading-skeleton";
import BasicDatePicker from "../../../../../components/Datepicker/Datepicker";
import Dropdowns from "../../../../../components/Dropdowns/Dropdowns";
import Input from "../../../../../components/Inputs/Input";
import {
  getPrnQuoteModalList,
  getQuoteDetailById,
} from "../../../Services/QuoteService";
import { QuoteOrderContext } from "../../../context/QuoteOrderContext";
import { ResultsNotFound } from "../../../../../components/ResultsNotFound/ResultsNotFound";
const tagsMapper = {
  success: "Quoted",
  info: "Partially Quoted",
  warning: "Pending",
  issued: "Expired",
};
const dropdownIds = [74];
const dropdownNames = {
  74: "currencyId",
};
const SearchBarContainer = () => {
  const [inputValue, setInputValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");

  const didMount = useRef(false);
  const handleChange = (event) => {
    setInputValue(event.target.value);
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, 1000); // 500ms delay

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    //
  }, [debouncedValue]);
  return <input placeholder="Search" onChange={handleChange} />;
};
export const QuoteVendorPRNList = ({ onClose, vendorInfo, quote }) => {
  const propertyRefs = useRef({});
  const [tooltips, setTooltips] = useState({});
  const [dataList, setDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const listRef = useRef(null);
  const switchedTagsMapper = Object.fromEntries(
    Object.entries(tagsMapper).map(([key, value]) => [value, key])
  );

  const [openSubStates, setOpenSubStates] = useState({});

  const getSortingOrder = (order) => {
    // setSortingOrder(order);
  };
  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollHeight - (scrollTop + 3) <= clientHeight) {
      // if (!setLoadingPartsReq) requestNextPage();
    }
  };
  useEffect(() => {
    const newTooltips = {};
    Object.entries(propertyRefs.current).forEach(([key, el]) => {
      if (el) {
        newTooltips[key] = el.scrollWidth > el.clientWidth;
      }
    });
    setTooltips(newTooltips);
    if (vendorInfo) {
      setIsLoading(true);
      getPrnQuoteModalList(quote.id, vendorInfo.vendor_id)
        .then((response) => {
          setIsLoading(false);
          if (response.data.responseCode === 200) {
            const inventoryArray = response.data.load.map((item) => {
              return {
                ...item,
                date_request_required: item.date_request_required.split("T")[0],
              };
            });
            setDataList(inventoryArray);
          }
        })
        .catch((err) => {
          setIsLoading(false);
        });
    }
  }, [vendorInfo]);
  const toggleOpenSubState = (aircraftId, open) => {
    closeAllOpenSubStates();
    setTimeout(() => {
      setOpenSubStates((prevState) => ({
        ...prevState,
        [aircraftId]: open,
      }));
    }, 100);
  };
  const closeAllOpenSubStates = () => {
    setOpenSubStates((prevState) => {
      const newState = {};
      Object.keys(prevState).forEach((key) => {
        newState[key] = false;
      });
      return newState;
    });
  };
  return (
    <>
      <div className="vendor-selected-modal-quote-container-header">
        <div className="vendor-selected-modal-quote-container-header-vendor">
          <div className="vendor-selected-score-container">
            <i className="icon-favorite"> </i>
            <b>{vendorInfo.score}</b>
          </div>

          <b>
            {vendorInfo.vendor_id} - {vendorInfo.vendor_name}
          </b>
          <Tag
            style={{ width: "9vw" }}
            tag={vendorInfo.status}
            type={switchedTagsMapper[vendorInfo.status]}
          ></Tag>
        </div>
        <div className="search-bar-input">
          <SearchBarContainer />
          <i className="icon-search"></i>
        </div>
      </div>
      <hr></hr>
      <div className="vendor-selected-modal-quote-container-body">
        <div className="sorting-header">
          <div className="sorting-free-slot"> </div>
          <Sorting
            onOrderChange={getSortingOrder}
            ignoreProperties={true}
            displayButton={false}
        showHeaderOrder={true}
            initialSort="date_request_required"
            properties={{
              part_id: "PN",
              part_request_id: "PRN",
              code: "Location",
              site_code: "Site",
              company_id: "Company",
              quantity_required: "Required",
              date_request_required: "RequiredDate",
            }}
          ></Sorting>
        </div>
        <div
          className="vendor-selected-modal-quote-container-body-list"
          ref={listRef}
          onScroll={handleScroll}
        >
          {isLoading ? (
            Array.from({ length: 7 }).map((_, idx) => (
              <div key={idx} className="item-container-skeleton">
                <Skeleton
                  style={{ borderRadius: "10px" }}
                  height="1.68rem"
                  width={40}
                />
                <div className="item-skeleton-content">
                  <Skeleton height={20} width="80%" />
                </div>
                <Skeleton height={30} width="7rem" />
              </div>
            ))
          ) : dataList.length === 0 ? (
            <ResultsNotFound />
          ) : (
            dataList.map((item, idx) => (
              <Expandable
                key={`${item?.id}-${idx}-prn-list`}
                name={`${item?.id}-pen-list-${idx}`}
                summary={
                  <React.Fragment key={`${item.id}-${idx}-prn`}>
                    <div
                      className={`item-quote-prn-vendor-modal-container ${
                        openSubStates[item?.id] ? "active" : ""
                      }`}
                    >
                      {/* <PartImage item={item} /> */}
                      {[
                        "part_number",
                        "part_request_id",
                        "code",
                        "site_code",
                        "company_name",
                        "quantity_required",
                        "date_request_required",
                      ].map((label) => (
                        <div
                          className={`property ${
                            label === "quantity_required" ||
                            label === "date_request_required"
                              ? "centerItem"
                              : ""
                          }`}
                          key={label}
                        >
                          <Tooltip
                            title={
                              tooltips[`${item.id}-${label}`] ? item[label] : ""
                            }
                            arrow
                          >
                            {label == "quantity_required" ||
                            label == "date_request_required" ? (
                              <p
                                className="bold-font"
                                ref={(el) => {
                                  if (el) {
                                    propertyRefs.current[
                                      `${item.id}-${label}`
                                    ] = el;
                                  }
                                }}
                              >
                                {label == "quantity_required"
                                  ? item[label] + " " + item["uom_abrevation"]
                                  : item[label]}
                              </p>
                            ) : label == "company_name" ? (
                              <p
                                className="light-font"
                                style={{ marginLeft: "2vw" }}
                                ref={(el) => {
                                  if (el) {
                                    propertyRefs.current[
                                      `${item.id}-${label}`
                                    ] = el;
                                  }
                                }}
                              >
                                {item[label]}
                              </p>
                            ) : (
                              <p
                                className="light-font"
                                ref={(el) => {
                                  if (el) {
                                    propertyRefs.current[
                                      `${item.id}-${label}`
                                    ] = el;
                                  }
                                }}
                              >
                                {item[label]}
                              </p>
                            )}
                          </Tooltip>
                        </div>
                      ))}
                      {item?.status == "Quoted" && (
                        <div className="item-quote-prn-status">
                        <Tooltip title={"Quoted"} arrow>
                          <i className="icon-confirmation"></i>
                        </Tooltip></div>
                      )}
                    </div>
                  </React.Fragment>
                }
                isOpen={openSubStates[item?.id]}
                onToggle={(open) => toggleOpenSubState(item?.id, open)}
              >
                {openSubStates[item?.id] && (
                  <DropdownsProvider>
                    <QuoteVendorCurrencyInfo
                      prnInfo={item}
                      vendorInfo={vendorInfo}
                    ></QuoteVendorCurrencyInfo>
                  </DropdownsProvider>
                )}
              </Expandable>
            ))
          )}
        </div>
      </div>
    </>
  );
};
const defaultGeneralEmptyValues = {
  currencyId: null,
  responseDate: new Date().toISOString().split("T")[0],
  unitCost: null,
  id: null,
  discountApplied: null,
  taxIncluded: null,
  leadDays: null,
  isOnEdition: false,
};
const QuoteVendorCurrencyInfo = ({ onClose, prnInfo, vendorInfo }) => {
  const [values, setValues] = useState({
    ...defaultGeneralEmptyValues,
    id: prnInfo.id,
  });
  const [defaults, setDefaults] = useState({
    ...defaultGeneralEmptyValues,
    id: prnInfo.id,
  });
  const [displayForm, setDisplayForm] = useState(false);
  const [subTotal, setSubTotal] = useState(null);
  const [totalCostPn, setTotalCostPn] = useState(null);
  const {
    isOnEdition,
    setIsOnEdition,
    quoteVendorFormState,
    setQuoteVendorFormState,
  } = useContext(QuoteOrderContext);
  const {
    dropdownsData,
    setDropdownsData,
    setDropdownIds,
    dropdownDefaultOptions,
  } = useContext(DropdownsContext);
  useEffect(() => {
    setDropdownIds(dropdownIds);
  }, []);

  useEffect(() => {
    const savedValues =
      quoteVendorFormState?.[prnInfo?.id]?.[vendorInfo.vendor_id];
    getQuoteDetailById(prnInfo.id)
      .then((response) => {
        if (response.data.responseCode === 200) {
          const {
            responseDate,
            unitCost,
            leadDays,
            discountApplied,
            taxIncluded,
            currencyId,
          } = response.data.load;

          const serviceValues = {
            responseDate,
            unitCost,
            leadDays,
            discountApplied,
            taxIncluded,
            currencyId,
            id: prnInfo.id,
          };

          if (savedValues) {
            const merged = {
              ...serviceValues,
              ...savedValues,
            };
            setValues(merged);
            setDefaults(merged);
          } else {
            const merged = {
              ...serviceValues,
            };

            setValues(merged);
            setDefaults(merged);
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching quote details:", error);
      });
  }, [prnInfo.id, vendorInfo.vendor_id]);

  useEffect(() => {
    if (dropdownsData && dropdownsData.length > 0) {
      setDisplayForm(true);
    }
  }, [dropdownsData]);

  useEffect(() => {
    const unitCost = parseFloat(values["unitCost"]) || 0;
    const discount = parseFloat(values["discountApplied"]) || 0;
    const taxIncluded = parseFloat(values["taxIncluded"]) || 0;
    const subTotalValue = unitCost * prnInfo.quantity_required || 0;
    setSubTotal(subTotalValue.toFixed(2));
    setTotalCostPn((subTotalValue - discount + taxIncluded).toFixed(2));
    if (prnInfo.id) {
      setQuoteVendorFormState((prev = {}) => ({
        ...prev,
        [prnInfo.id]: {
          ...(prev?.[prnInfo.id] || {}),
          [vendorInfo.vendor_id]: values,
        },
      }));
    }
  }, [values]);

  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    setDropdownsData((prevDropdowns) =>
      prevDropdowns.map((filter) => {
        if (filter.id === dropdownId) {
          return {
            ...filter,
            parentValues,
            dependenciesToUpdate,
            reload: true,
          };
        }
        return filter;
      })
    );
  };
  const resetDropdownsReload = () => {
    setDropdownsData((filterState) => {
      if (filterState.length > 0) {
        return filterState.map((e) => {
          if (e.reload) {
            return { ...e, reload: false };
          }
          return e;
        });
      }
      return filterState;
    });
  };
  const changeValue = (e) => {
    const { name, value, completeValue } = e.target;
    setValues((prev) => {
      return {
        ...prev,
        ...{ [name]: value },
        isOnEdition: true,
      };
    });
  };

  const handleDropdownValue = (value, name, data) => {
    changeValue({ target: { name, value: value[data], completeValue: value } });

    setDefaults((prev) => ({
      ...prev,
      ...{ [name]: " " },
    }));
  };
  const changeValueDate = (newValue, name) => {
    const completeValue = newValue?.format("YYYY-MM-DD");
    setValues((prev) => {
      return {
        ...prev,
        ...{ [name]: completeValue },
        isOnEdition: true,
      };
    });
  };
  return (
    <div className="quote-vendor-currency-info-container">
      <div className="quote-vendor-currency-info-container-header">
        <b>Currency</b>
        <b>Response Date</b>
        <b>Lead Days</b>
        <b>Unit Cost</b>
        <b>Subtotal</b>
        <b>Discount Applied</b>
        <b>Tax Included</b>
        <b>Total Cost PN</b>
      </div>
      <div className="quote-vendor-currency-info-container-body">
        {displayForm ? (
          <Dropdowns
            context={{
              dropdownsData,
              setDropdownsData,
              setDropdownIds,
              dropdownDefaultOptions,
            }}
            updateDropdown={updateDropdown}
            resetDropdownsReload={resetDropdownsReload}
            disabled={!isOnEdition}
            placeholder={"--"}
            hideErrorLabel={true}
            hideLabel={true}
            required={true}
            key={74}
            onOptionSelect={(value, data) =>
              handleDropdownValue(value, dropdownNames[74], data)
            }
            hideRequiredLabel={true}
            showPagination={false}
            data={dropdownsData.find((e) => e.id === 74)}
            preSelectValue={defaults?.[dropdownNames[74]]}
          />
        ) : (
          <Skeleton height="1.5rem" width="100%" />
        )}
        {!displayForm ? (
          <Skeleton height={"1.5rem"} width={"100%"} />
        ) : (
          <BasicDatePicker
            style={{ gridColumn: "span 1" }}
            label={""}
            disabled={!isOnEdition}
            onChange={(newValue) => {
              changeValueDate(newValue, "responseDate");
            }}
            hideErrorLabel={true}
            disablePastDates={true}
            isDateTime={false}
            value={values["responseDate"]}
            name="responseDate"
          ></BasicDatePicker>
        )}
        {!displayForm ? (
          <Skeleton height={"1.5rem"} width={"100%"} />
        ) : (
          <Input
            name="leadDays"
            required={true}
            disableAutocomplete={true}
            label={""}
            onChange={changeValue}
            disabled={!isOnEdition}
            hideErrorLabel={true}
            placeholder={"--"}
            isNumeric={true}
            value={values["leadDays"]}
          />
        )}
        {!displayForm ? (
          <Skeleton height={"1.5rem"} width={"100%"} />
        ) : (
          <Input
            name="unitCost"
            required={true}
            disableAutocomplete={true}
            onChange={changeValue}
            label={""}
            disabled={!isOnEdition}
            hideErrorLabel={true}
            isNumeric={true}
            placeholder={"--"}
            value={values["unitCost"]}
          />
        )}
        {!displayForm ? (
          <Skeleton height={"1.5rem"} width={"100%"} />
        ) : (
          <Input
            name="subTotal"
            required={true}
            disableAutocomplete={true}
            hideErrorLabel={true}
            isNumeric={true}
            label={""}
            disabled={true}
            placeholder={"--"}
            value={subTotal}
          />
        )}
        {!displayForm ? (
          <Skeleton height={"1.5rem"} width={"100%"} />
        ) : (
          <Input
            name="discountApplied"
            required={true}
            disableAutocomplete={true}
            onChange={changeValue}
            hideErrorLabel={true}
            isNumeric={true}
            disabled={!isOnEdition || subTotal <= 0}
            limit={subTotal}
            placeholder={"--"}
            label={""}
            value={values["discountApplied"]}
          />
        )}
        {!displayForm ? (
          <Skeleton height={"1.5rem"} width={"100%"} />
        ) : (
          <Input
            name="taxIncluded"
            required={true}
            disableAutocomplete={true}
            onChange={changeValue}
            hideErrorLabel={true}
            isNumeric={true}
            disabled={!isOnEdition}
            label={""}
            placeholder={"--"}
            value={values["taxIncluded"]}
          />
        )}
        {!displayForm ? (
          <Skeleton height={"1.5rem"} width={"100%"} />
        ) : (
          <Input
            name="totalCostPn"
            required={true}
            disableAutocomplete={true}
            hideErrorLabel={true}
            isNumeric={true}
            label={""}
            disabled={true}
            placeholder={"--"}
            value={totalCostPn}
          />
        )}
      </div>
    </div>
  );
};
